exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-8c17de20] .el-dialog__title {\n  font-size: 25px;\n  color: #606266;\n}\n[data-v-8c17de20] .el-form-item__label {\n  font-family: Arial, Helvetica, sans-serif;\n}\n[data-v-8c17de20] .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {\n  content: \"\";\n  color: #f56c6c;\n  margin-left: -4px;\n}\n[data-v-8c17de20] .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {\n  content: \"*\";\n  color: #f56c6c;\n  margin-left: 3px;\n}\n", ""]);

// exports
